var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersRosepink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15717",
    "data-name": "Group 15717",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.639,
    height: 62.516,
    viewBox: "0 0 71.639 62.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16476",
    "data-name": "Rectangle 16476",
    width: 71.639,
    height: 62.516,
    fill: "#ef6286"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15716",
    "data-name": "Group 15716",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41314",
    "data-name": "Path 41314",
    d: "M78.2,136.862q-6.364,0-12.729,0a4.932,4.932,0,0,1-4.838-2.805,4.7,4.7,0,0,1-.486-1.87c-.09-3.028-.154-6.058-.139-9.087a24.049,24.049,0,0,1,1.281-8.8c2.259-5.746,6.578-9.1,12.533-10.416a32.66,32.66,0,0,1,8.213-.328,15.127,15.127,0,0,1,9.181,3.43A16.841,16.841,0,0,1,97.891,120.6q.032,5.593-.012,11.187a6.673,6.673,0,0,1-.32,1.912c-.739,2.36-2.659,2.977-4.823,3.033-4.845.126-9.692.175-14.539.255,0-.041,0-.083,0-.125",
    transform: "translate(-43.188 -74.471)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41315",
    "data-name": "Path 41315",
    d: "M84.387,12.11A12.173,12.173,0,1,1,96.516,24.336,12.134,12.134,0,0,1,84.387,12.11",
    transform: "translate(-60.741 0)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41316",
    "data-name": "Path 41316",
    d: "M18.771,105.667a19.683,19.683,0,0,0-5.421,9.914,43.8,43.8,0,0,0-.7,9.244c0,2.444,0,4.887,0,7.41a5.164,5.164,0,0,1-.74.1c-2.54.005-5.081.026-7.621-.013a4.13,4.13,0,0,1-4.29-4.4q0-7.374,0-14.748a9.294,9.294,0,0,1,8.07-9.539,18.18,18.18,0,0,1,7.628.325,7.892,7.892,0,0,1,3.072,1.711",
    transform: "translate(0 -74.413)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41317",
    "data-name": "Path 41317",
    d: "M194.858,132.243c0-2.641,0-5.2,0-7.762a41.1,41.1,0,0,0-.685-8.964c-.861-3.84-2.038-5.962-5.385-9.834a6.912,6.912,0,0,1,3.317-1.785,19,19,0,0,1,8.315-.048,9.292,9.292,0,0,1,7.1,9.145q.008,7.444,0,14.888a4.145,4.145,0,0,1-4.018,4.412c-2.72.131-5.451.045-8.178.045a2.286,2.286,0,0,1-.47-.1",
    transform: "translate(-135.888 -74.435)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41318",
    "data-name": "Path 41318",
    d: "M20.181,31.948a7.691,7.691,0,1,1-7.695,7.661,7.668,7.668,0,0,1,7.695-7.661",
    transform: "translate(-8.988 -22.996)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41319",
    "data-name": "Path 41319",
    d: "M203.636,39.621a7.7,7.7,0,1,1-7.681-7.674,7.72,7.72,0,0,1,7.681,7.674",
    transform: "translate(-135.497 -22.996)",
    fill: "#ef6286"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersRosepink);
export default __webpack_public_path__ + "static/media/customers-rosepink.2e0a4e95cd40cd0f44729fdb19152dd5.svg";
export { ForwardRef as ReactComponent };